import { render } from "./AppOrderConfirmation.vue?vue&type=template&id=c50600da&scoped=true"
import script from "./AppOrderConfirmation.vue?vue&type=script&lang=js"
export * from "./AppOrderConfirmation.vue?vue&type=script&lang=js"

import "./AppOrderConfirmation.vue?vue&type=style&index=0&id=c50600da&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50600da"]])

export default __exports__